import { Card, Divider, Typography } from "antd";
import { useState } from "react";
import GraphView from "../../../components/EOL/EOL-dashboard/GraphView";
import CardView from "../../../components/EOL/EOL-dashboard/CardView";
import "../../../styles/global-ui.css";

const EOLdashboardPage = ({ userData }) => {
  const [graphData, setGraphData] = useState(null);

  return (
    <div className="page-container">
      <div className="page-header">
        <div className="page-title-wrap">
          <Typography.Title level={3} className="page-title">
            End Of Line Dispatch Dashboard
          </Typography.Title>
          <Typography.Text className="page-subtitle">
            View area-wise quantity summary and quick insights
          </Typography.Text>
        </div>
      </div>

      <Divider className="page-divider" />

      <CardView userData={userData} setGraphData={setGraphData} />

      {graphData && (
        <Card
          className="modern-card dashboard-chart-card"
          title="Quantity Overview"
        >
          <GraphView graphData={graphData} />
        </Card>
      )}
    </div>
  );
};

export default EOLdashboardPage;